import classnames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import { chainDecorators, memoized } from '../../utils/ReactUtils'
import ImageStatic from '../ImageStatic'
import Link from '../Link'

import styles from './styles'


const decorators = [
  memoized,
]

function ArrowLink(props) {
  const { className, left, label, route, routeParams, icon, onClick } = props

  return (
    <span className={classnames('container', { left }, className)}>
      <Link
        route={route}
        routeParams={routeParams}
        onClick={onClick}
      >
        <ImageStatic
          className="icon"
          // src="/images/icons/arrow-right-white.svg"
          src={icon}
        />
        <span>{label}</span>
      </Link>
      <style jsx>{styles}</style>
    </span>
  )
}

ArrowLink.propTypes = {
  label: PropTypes.string.isRequired,
  route: PropTypes.string.isRequired,
  left: PropTypes.bool,
  // eslint-disable-next-line
  routeParams: PropTypes.object,
  onClick: PropTypes.func,
  className: PropTypes.string,
  icon: PropTypes.string,
}

ArrowLink.defaultProps = {
  left: false,
  routeParams: {},
  className: null,
  icon: '',
  onClick: () => null
}

ArrowLink = chainDecorators(decorators, ArrowLink)

export default ArrowLink
